import React from 'react'
import Navbar from '../components/Navbar'
import HakkimizdaComp from '../components/Hakkimizda_comp'
import Footer from '../components/Footer'

function Hakkimizda() {
  return (
    <div>
        <Navbar />
        <HakkimizdaComp />
        <Footer />
    </div>
  )
}

export default Hakkimizda
